module.exports = __webpack_public_path__ + "img/gw.5ecbd93c.svg";